import React, { useContext, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { configData } from "../../services/api-config";
import { AuthContext } from '../../context/auth.context';
import { Link, useNavigate } from 'react-router-dom';
import CustomInput from '../../components/custom/custom-input/CustomInput';
import styles from './LoginPage.module.scss';
import cn from "classnames";
import CustomButton from '../../components/custom/custom-button/CustomButton';
import LanguageSelector from '../../components/shared/LanguageSelector/LanguageSelector';

const LoginPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const auth = useContext(AuthContext);

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const [errorPassword, setErrorPassword] = useState();
    const [invalidEmail, setInvalidEmail] = useState();

    const [isLoading, setIsLoading] = useState(false);

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const handleLogin = () => {
        setInvalidEmail(null);
        setErrorPassword(null);

        if (!username || !password) {
            if (!username) {
                setInvalidEmail(t('login.emailEmptyError'));
            }
            if (!password) {
                setErrorPassword(t('login.passwordEmptyError'));
            }
            return;
        }

        const payload = {
            username: username ? username: username,
            password: password,
        }
        if (payload.username && payload.password) {
            console.log(validateEmail(payload.username))
            if (validateEmail(payload.username)) {
                setErrorPassword();
                setInvalidEmail();
                setIsLoading(true);
                axios
                    .get(configData.BASE_URL + 'api/v1/users/login', {
                        auth: payload,
                        withCredentials: true
                    })
                    .then((response) => {
                        console.log('login responce', response);
                        if (response.status == 200) {
                            response.data.isAuthenticated = true;
                            auth.login(response.data.accessToken);
                            response.data.userType === "expeditor" ? navigate("/orders-search") : navigate("/main");
                        }
                        setIsLoading(false);
                    })
                    .catch((error) => {
                        if (error && error.response && error.response.data && error.response.data.errorCode) {
                            setInvalidEmail(error.response.data.errorText);
                            setErrorPassword(error.response.data.errorText);
                        } else {
                            setErrorPassword(t('login.invalidCredentialsError'));
                            setInvalidEmail(t('login.invalidCredentialsError'));
                        }

                        setIsLoading(false);
                    });
            } else {
                setInvalidEmail(t('login.invalidEmailFormat'))
            }
        }
    }

    const handleKeyPress = e => {
        if (e.key === 'Enter') {
            handleLogin()
        }
    };

    return (
        <>
            <div className={styles.containerReg}>
                <div className={styles.containerReg_wallpaper}>
                    <div className={styles.card}>
                        <div className={styles.card_topbar}>
                            <div className={styles.card_logo}>
                                <img src="/icons/ic_biny_dark.svg" alt="logo" />
                            </div>
                            <div className={styles.card_lang}>
                                {/* <img src="/icons/country_rus.svg" alt="lang" /> */}
                                {/* <span>Рус</span> */}
                                <LanguageSelector />
                            </div>
                        </div>
                        <div className={styles.card_content}>
                            <div className={styles.card_title}>{t('login.welcomeMessage')}</div>
                            <div className={styles.card_form}>
                                <CustomInput placeholder={t('login.emailPlaceholder')} labelText={t('login.emailLabel')} inputType="text" isDeleteText={true} onChangeValue={setUsername} value={username} errorText={invalidEmail}
                                />
                                <CustomInput placeholder={t('login.passwordPlaceholder')} labelText={t('login.passwordLabel')} inputType="text" isPasswordEye={true} onKeyPress={handleKeyPress} value={password} onChangeValue={setPassword} errorText={errorPassword} />
                                <div className={styles.card_text}>
                                    <span>{t('login.forgotPasswordPrompt')}</span>
                                    <Link to="/forgot-password">{t('login.recoverHereLink')}</Link>
                                </div>
                            </div>
                            <div className={styles.btns}>
                                <CustomButton isFall text={t('login.loginButton')} isLoading={isLoading} onClick={handleLogin} />
                                <div className={styles.btns_text}>
                                    <div className={styles.btns_before}> </div>
                                    <div className={styles.btns_textDashes}>{t('login.registrationPrompt')}</div>
                                    <div className={styles.btns_before}></div>
                                </div>
                                <CustomButton isFall text={t('login.createAccountButton')} isWhite={true} onClick={() => navigate('/registration')} />
                            </div>
                        </div>
                        <div className={styles.card_footer}>
                            <span>
                                {t('login.termsAgreement')}<a href="https://app.biny.co/privacy-policy.pdf" target="_blank" rel="noopener noreferrer">{t('login.termsLink')}</a> {t('login.service')}
                            </span>
                        </div>
                    </div>
                    <div className={styles.right}>
                        <div className={styles.banner}>
                            <div className={styles.banner_dec}>
                                <div className={styles.banner_title}>{t('login.bannerTitle')}</div>
                                <div className={styles.banner_text}>{t('login.bannerText')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LoginPage;
